"use strict";

exports.__esModule = true;
exports.CycleSplitter = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function makeState(props) {
  var classification = props.classification;
  var interval = classification.interval;
  var splitAt = classification.interval.startMillis + Math.round((classification.interval.endMillis - classification.interval.startMillis) / 2);
  var first = {
    type: "CycleClassification",
    interval: {
      startMillis: interval.startMillis,
      endMillis: splitAt
    },
    value: Object.assign({}, classification.value)
  };
  var second = {
    type: "CycleClassification",
    interval: {
      startMillis: splitAt,
      endMillis: interval.endMillis
    },
    value: Object.assign({}, classification.value)
  };
  return {
    parts: [first, second],
    disableSplit: true,
    initialClassification: classification
  };
}

/**
 * Render-prop powered cycle splitter.
 */
var CycleSplitter = exports.CycleSplitter = /*#__PURE__*/function (_Component) {
  function CycleSplitter() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    _this.handleChange = function (parts) {
      _this.setState(function (prevState) {
        var initialValue = prevState.initialClassification.value;
        var disableSplit = parts.every(function (_ref) {
          var value = _ref.value;
          return value.state === initialValue.state && value.activity === initialValue.activity;
        });
        return Object.assign({}, prevState, {
          parts: parts,
          disableSplit: disableSplit
        });
      });
    };
    return _this;
  }
  _inheritsLoose(CycleSplitter, _Component);
  var _proto = CycleSplitter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      classification = _this$props.classification,
      plantStateActivities = _this$props.plantStateActivities,
      children = _this$props.children;
    var _this$state = this.state,
      parts = _this$state.parts,
      disableSplit = _this$state.disableSplit;
    return children({
      classification: classification,
      plantStateActivities: plantStateActivities,
      parts: parts,
      disableSplit: disableSplit,
      onChange: this.handleChange
    });
  };
  return CycleSplitter;
}(_react.Component);
CycleSplitter.getDerivedStateFromProps = function (newProps, prevState) {
  var _prevState$initialCla = prevState.initialClassification,
    _prevState$initialCla2 = _prevState$initialCla.value,
    oldState = _prevState$initialCla2.state,
    oldActivity = _prevState$initialCla2.activity,
    _prevState$initialCla3 = _prevState$initialCla.interval,
    startMillis = _prevState$initialCla3.startMillis,
    endMillis = _prevState$initialCla3.endMillis;
  if (newProps.classification && newProps.classification.value) {
    var _newProps$classificat = newProps.classification.value,
      newState = _newProps$classificat.state,
      newActivity = _newProps$classificat.activity;
    var _newProps$classificat2 = newProps.classification.interval,
      newStart = _newProps$classificat2.startMillis,
      newEnd = _newProps$classificat2.endMillis;
    if (newState !== oldState || newActivity !== oldActivity) {
      return makeState(newProps);
    } else if (startMillis !== newStart && endMillis !== newEnd) {
      return makeState(newProps);
    }
  }
  return prevState;
};